import { getConsumeOrderList } from '@/api/dashboard/dashboard';
// import initFiltersStore from '@/store/modules/filters';
import { getFilters, formatDate } from '@/utils/index';
const FETCH_CONSUME_LIST = 'FETCH_CONSUME_LIST';
const FETCH_DATA = 'FETCH_DATA';

// const initFilters = () => ({
//   operateId: undefined,
//   areaId: undefined,
//   timeType: 0, // 0 本日，1 本月， 2 本年
// });
// const filtersStore = initFiltersStore(initFilters);
const nowTime = new Date();

const state = () => ({
  loading: false,
  list: [],
  consumeCountVo: {
    payMen: 0,
    payableMoney: 0,
  },
});

const getters = {
  consumeList: state => state.list,
  consumeCount: state => state.consumeCountVo,
  loading: state => state.loading,
};

const actions = {
  getConsumeOrderList({ commit, rootGetters }) {
    commit(FETCH_DATA, true);
    let entity = getFilters(rootGetters['Dashboard/customerData/filters']);
    switch (entity.timeType) {
      case 1:
        entity.month = formatDate(nowTime, 'yyyy-MM');
        break;
      case 2:
        entity.year = formatDate(nowTime, 'yyyy');
        break;
      case 0:
      default:
        entity.date = formatDate(nowTime, 'yyyy-MM-dd');
        break;
    }
    return getConsumeOrderList({
      data: entity,
    })
      .then(res => {
        const { data, consumeCountVo } = res;
        commit(FETCH_CONSUME_LIST, { list: data, consumeCountVo });
        commit(FETCH_DATA, false);
      })
      .catch(err => {
        console.error(err);
        commit(FETCH_DATA, false);
      });
  },
};

const mutations = {
  [FETCH_CONSUME_LIST](state, data) {
    state.list = data.list;
    state.consumeCountVo = data.consumeCountVo;
  },
  [FETCH_DATA](state, fetching) {
    state.loading = fetching;
  },
};

export default {
  namespaced: true,
  // modules: { filtersStore },
  state,
  getters,
  actions,
  mutations,
};
